import { ActionCreator } from 'redux';
import { FileInfo } from '@dev/ee-api/ee-api-models';

import {
    LoadFilesAction,
    StartLoadingFilesAction,
    LoadingFilesErrorAction,
    LoadingFilesSuccessAction,
    DeleteFileAction,
    DeleteFileStartAction,
    DeleteFileSuccessAction,
    DeleteFileErrorAction,
    DeleteFilesListAction,
    DeleteFilesListStartAction,
    DeleteFilesListErrorAction,
    DeleteFilesListSuccessAction,
} from './types';

export const LoadUserFiles: ActionCreator<LoadFilesAction> = () => {
    return {
        type: '@@userFiles/LOAD_USER_FILES',
    };
};

export const StartFileLoad: ActionCreator<StartLoadingFilesAction> = () => {
    return {
        type: '@@userFiles/START_LOADING_FILES',
    };
};

export const FileLoadError: ActionCreator<LoadingFilesErrorAction> = () => {
    return {
        type: '@@userFiles/LOADING_FILES_ERROR',
    };
};

export const FileLoadSuccess: ActionCreator<LoadingFilesSuccessAction> = (files: FileInfo[]) => {
    return {
        type: '@@userFiles/LOADING_FILES_SUCCESS',
        payload: {
            files,
        },
    };
};

export const DeleteFile: ActionCreator<DeleteFileAction> = (fileName: string, imageDelete: boolean) => {
    return {
        type: '@@userFiles/DELETE_FILE',
        payload: {
            fileNameToDelete: fileName,
            imageDelete,
        },
    };
};

export const DeleteFileStart: ActionCreator<DeleteFileStartAction> = () => {
    return {
        type: '@@userFiles/DELETE_FILE_START',
    };
};

export const DeleteFileSuccess: ActionCreator<DeleteFileSuccessAction> = (files: FileInfo[]) => {
    return {
        type: '@@userFiles/DELETE_FILE_SUCCESS',
        payload: {
            files,
        },
    };
};

export const DeleteFileError: ActionCreator<DeleteFileErrorAction> = () => {
    return {
        type: '@@userFiles/DELETE_FILE_ERROR',
    };
};

export const DeleteFilesList: ActionCreator<DeleteFilesListAction> = (filesList: string[], imagesDelete: boolean) => {
    return {
        type: '@@userFiles/DELETE_FILES_LIST',
        payload: {
            filesToDelete: filesList,
            imagesDelete,
        },
    };
};

export const DeleteFilesListStart: ActionCreator<DeleteFilesListStartAction> = () => {
    return {
        type: '@@userFiles/DELETE_FILES_LIST_START',
    };
};

export const DeleteFilesListSuccess: ActionCreator<DeleteFilesListSuccessAction> = (files: FileInfo[]) => {
    return {
        type: '@@userFiles/DELETE_FILES_LIST_SUCCESS',
        payload: {
            files,
        },
    };
};

export const DeleteFilesListError: ActionCreator<DeleteFilesListErrorAction> = () => {
    return {
        type: '@@userFiles/DELETE_FILES_LIST_ERROR',
    };
};
